import PartnerCard from './PartnerCard.js';

export default function PartnerCardView({ partners }) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      {partners.map((partner) => (
        <PartnerCard key={partner.PartnerID} partner={partner} />
      ))}
    </div>
  );
}
